import React from "react";
import UserProfileComponent from "../UserProfileComponent";
import { ClearSessionItems } from "../../helper/appsession";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { companySlice, setCompany } from "../../redux/companySlice";
import ChangeCompanyComponent from "../Shared/ChangeCompanyComponent";

export default function HeaderComponent() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const reduxCompany = useSelector((state) => state?.company?.data);
  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <Icon icon="material-symbols:menu-open-rounded" width="24" height="24" />
            </a>
          </li>
          <li className="nav-item">
            <h3 className="pagetitle mb-0 text-primary" id="pageTitle"></h3>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          {/* <li className="nav-item">
              <a
                className="nav-link"
                data-widget="fullscreen"
                href="#"
                role="button"
              >
                <i className="fas fa-expand-arrows-alt" />
              </a>
            </li> */}
            {/* <li className="nav-item">
            <span
              className="nav-link"
              data-widget="fullscreen"
              role="button"
            >
              <img
                src={`./assets/img/Company/${reduxCompany?.id}/company-logo.png`}
                alt="VISHWAM"
                className="brand-image"
                width=""
              />
            </span>
          </li> */}
          <li className="nav-item">
            <a
              className="nav-link dropdown-toggle"
              type="button"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-user" />
              &nbsp;{user?.firstName ? user?.firstName + " " + user?.lastName : user?.userName}
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {/* <li className="nav-item">
                <span
                  className="nav-link"
                  data-widget="pushmenu"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    dispatch(
                      setCompany({
                        id: reduxCompany?.id || 1,
                        isChangeCompanyModalOpen: !reduxCompany?.isChangeCompanyModalOpen,
                      })
                    );
                  }}
                >
                  <i class="fas fa-exchange-alt"></i>  Switch Company                  
                </span>
              </li> */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  onClick={() => {
                    ClearSessionItems();
                    localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  <i className="fas fa-sign-out-alt"></i> Exit
                </a>
              </li>
            </div>
          </li>
          {/* Change Company */}          
        </ul>
      </nav>
      {/* <div>
        <div className="flex-column justify-content-center align-items-center" />
       
      </div> */}
      {/* {reduxCompany?.isChangeCompanyModalOpen && <ChangeCompanyComponent />} */}
    </>
  );
}
